import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7dc108ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "microgesture-infos" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Name", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Text description", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Objects "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "small-text" }, "(coma separated, no upper case)")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Grasps "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "small-text" }, "(coma separated, no upper case)"),
  /*#__PURE__*/_createTextVNode(": ")
], -1))
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, " Camera ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, " Glove ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, " Custom ", -1))
const _hoisted_12 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = { class: "button-holder" }

import InputImage from '@/components/UI/InputImage'
import Input from '@/components/UI/InputComponent.vue'
import MicrogestureInput from '@/components/Microgesture/MicrogestureInput'
import Button from '@/components/UI/ButtonComponent.vue'

import { ref, inject, onMounted } from 'vue'
import router from '@/router'
import store from '@/store'


export default {
  __name: 'MMList',
  props: ['data'],
  emits: ['previous', 'next'],
  setup(__props, { emit: emits }) {

const props = __props;

const axios = inject('axios')




const mmList = ref([])
const reload = ref(0)

function previous () {
  // localStorage.removeItem('paperDescription')
  emits('previous')
}

function addMicrogesture () {
  mmList.value.push(
    {
      name: '',
      textDescription: '',
      imageDescription: '',
      object: '',
      grasp: [],
      customGrasp: '',
      capture: '',
      customCapture: '',
      microgesture: null
    }
  )
}

function submit () {
  const _mmList = []
  for (let i = 0; i < mmList.value.length; i++) {
    const mm = {}
    mm.name = mmList.value[i].name
    mm.textDescription = mmList.value[i].textDescription
    mm.imageDescription = mmList.value[i].imageDescription
    mm.µGlyphe = mmList.value[i].microgesture
    mm.object = mmList.value[i].object
    mm.grasp = mmList.value[i].grasp
    mm.customGrasp = mmList.value[i].customGrasp
    mm.capture = (mmList.value[i].capture === 'Custom') ? mmList.value[i].customCapture : mmList.value[i].capture
    _mmList.push(mm)
  }
  axios.post(`/api/mms/${props.data.citationKey}`, {
    content: {
      citationKey: props.data.citationKey, mmList: _mmList
    }
  }).then(() => {
    if (store.isModo) {
      previous()
    } else {
      localStorage.removeItem('paperDescription')
      router.push('/')
    }
  })
}

onMounted(() => {
  axios.get(`/api/mms/${props.data.citationKey}`)
    .then((l) => {
      const mmList_ = l.data.mmList
      mmList.value = []
      for (let i = 0; i < mmList_.length; i++) {
        const mm = {}
        mm.name = mmList_[i].name
        mm.textDescription = mmList_[i].textDescription
        mm.imageDescription = mmList_[i].imageDescription
        mm.microgesture = mmList_[i].µGlyphe
        mm.object = mmList_[i].object
        mm.grasp = (mmList_[i].grasp) ? mmList_[i].grasp : []
        mm.customGrasp = (mmList_[i].customGrasp) ? mmList_[i].customGrasp : ''
        mmList.value.push(mm)
      }
      reload.value++
    })
  addMicrogesture()
})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createElementBlock("span", { key: reload.value }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mmList.value.entries(), ([i, mm]) => {
        return (_openBlock(), _createElementBlock("span", {
          key: i,
          class: "microgesture-entry"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(Input, {
              class: "wide",
              label: "Name",
              modelValue: mm.name,
              "onUpdate:modelValue": $event => ((mm.name) = $event)
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _hoisted_3,
            _createVNode(Input, {
              class: "wide",
              label: "Text description",
              modelValue: mm.textDescription,
              "onUpdate:modelValue": $event => ((mm.textDescription) = $event)
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _hoisted_4,
            _createVNode(Input, {
              class: "wide",
              label: "Object",
              modelValue: mm.object,
              "onUpdate:modelValue": $event => ((mm.object) = $event)
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _hoisted_5,
            _createVNode(Input, {
              class: "wide",
              label: "Grasp",
              modelValue: mm.customGrasp,
              "onUpdate:modelValue": $event => ((mm.customGrasp) = $event)
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          (mm.name !== '')
            ? (_openBlock(), _createBlock(_unref(InputImage), {
                key: 0,
                modelValue: mm.imageDescription,
                "onUpdate:modelValue": $event => ((mm.imageDescription) = $event),
                imageName: `${__props.data.citationKey}_${mm.name}_${i}`
              }, null, 8, ["modelValue", "onUpdate:modelValue", "imageName"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(MicrogestureInput), {
            modelValue: mm.microgesture,
            "onUpdate:modelValue": $event => ((mm.microgesture) = $event),
            ref_for: true,
            ref: `microgestureInput_${i}`,
            class: "microgesture-input"
          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": $event => ((mm.capture) = $event)
                }, _hoisted_12, 8, _hoisted_7), [
                  [_vModelSelect, mm.capture]
                ]),
                (mm.capture === 'Custom')
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 0,
                      "onUpdate:modelValue": $event => ((mm.customCapture) = $event)
                    }, null, 8, _hoisted_13)), [
                      [_vModelText, mm.customCapture]
                    ])
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(Button, { onClick: addMicrogesture }, {
        default: _withCtx(() => [
          _createTextVNode("Add µG")
        ]),
        _: 1
      }),
      _createVNode(Button, { onClick: previous }, {
        default: _withCtx(() => [
          _createTextVNode("Previous")
        ]),
        _: 1
      }),
      _createVNode(Button, { onClick: submit }, {
        default: _withCtx(() => [
          _createTextVNode("Submit")
        ]),
        _: 1
      })
    ])
  ]))
}
}

}